AuthController = require 'controllers/base/auth_controller'

InvoiceScreen = require 'modules/invoice/views/invoice-screen'

module.exports = class InvoiceController extends AuthController
  menuTitle: 'invoice'

  invoice: ->
    @view = new InvoiceScreen 
      region: 'main'